import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/usr/src/node_modules/@heroui/link/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["User"] */ "/usr/src/node_modules/@heroui/user/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/usr/src/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/src/app/blog/[id]/breadcrumbs.js");
;
import(/* webpackMode: "eager" */ "/usr/src/src/app/blog/[id]/wp.module.css");
